export const printerService = {
    async getDefaultPrinter() {
        return new Promise((resolve, reject) => {
            if (!window.BrowserPrint) {
                reject(new Error('BrowserPrint not loaded. Please install Zebra BrowserPrint.'));
                return;
            }

            window.BrowserPrint.getDefaultDevice('printer', (device) => {
                if (device) {
                    resolve(device);
                } else {
                    reject(new Error('No printer found. Please connect a Zebra printer.'));
                }
            }, (error) => {
                reject(new Error('Failed to get printer: ' + error));
            });
        });
    },

    async printZPL(zpl) {
        try {
            const printer = await this.getDefaultPrinter();
            
            return new Promise((resolve, reject) => {
                printer.send(zpl, 
                    () => {
                        resolve({ success: true });
                    },
                    (error) => {
                        reject(new Error('Print failed: ' + error));
                    }
                );
            });
        } catch (error) {
            throw error;
        }
    },

    async testPrint() {
        const testZPL = `
^XA
^FO50,50^A0N,50,50^FDTest Print^FS
^FO50,150^A0N,30,30^FD${new Date().toLocaleString()}^FS
^XZ
        `.trim();

        return this.printZPL(testZPL);
    }
};
